export enum Behavior {
  Event = 0,
  Work = 1,
}

export enum BehaviorText {
  Event = 'event',
  Work = 'work',
}
